import styled from 'styled-components';

export const Content = styled.div``;

export const Div = styled.div``;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--s4);
`;

/* A parent picker does not need the card's full width to hold one name. */
export const Half = styled.div`
  max-width: 480px;
`;

/*
 * The design's `.actionbar`, on the card's foot. The save button used to sit
 * loose at the end of the stack with `marginLeft: auto`, which does nothing
 * to a static block element — so it rendered left-aligned under the form.
 */
export const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: var(--s2);
  margin: var(--s2) calc(var(--s5) * -1) calc(var(--s5) * -1);
  padding: var(--s4) var(--s5);
  border-top: 1px solid var(--line);
  background: var(--surface-alt);
`;
